import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Checkbox, FormControlLabel } from '@mui/material';
import React, { useEffect, useState } from 'react';

import UploadButton from '../../newcoach/components/uploadButton';
import { USER_IMAGE_DEFAULT } from '../../../common/staticData';
import GameService from '../../../services/game.service';

const UserDialog = ({ open, onClose, mode, user, refresh }) => {
    const [userLogo, setUserLogo] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [country, setCountry] = useState('');
    const [canShare, setCanShare] = useState(false);
    const [canUseApp, setCanUseApp] = useState(false);
    const [createEdits, setCreateEdits] = useState(false);
    const [isVerified, setIsVerified] = useState(true);
    const [subscription, setSubscription] = useState(null);
    const [sessionCount, setSessionCount] = useState(2);

    const saveChanges = () => {
        const onErr = (err) => {
            window.alert(err?.response?.data?.message || 'Failed to save changes. Please try again.');
        };
        if (mode === 'Add') {
            GameService.addNewUser({ first_name: firstName, last_name: lastName, email: email, phone: phone, country: country, logo: userLogo, sessionCount, role: subscription.id, can_share: canShare, can_use_app: canUseApp, create_edits: createEdits, is_verified: isVerified }).then((res) => {
                onClose();
                refresh((r) => !r);
            }).catch(onErr);
        } else {
            GameService.updateUser({ first_name: firstName, last_name: lastName, email: email, phone: phone, country: country, logo: userLogo, sessionCount, userId: user.id, can_share: canShare, can_use_app: canUseApp, create_edits: createEdits, is_verified: isVerified }).then((res) => {
                onClose();
                refresh((r) => !r);
            }).catch(onErr);
        }
    };

    useEffect(() => {
        if (mode === 'Add') {
            setUserLogo('');
            setFirstName('');
            setLastName('');
            setEmail('');
            setPhone('');
            setCountry('');
            setCanShare(false);
            setSessionCount(2);
            setCanUseApp(false);
            setCreateEdits(false);
            setIsVerified(true);
        } else {
            setUserLogo(user?.user_image ?? '');
            setFirstName(user?.first_name ?? '');
            setLastName(user?.last_name ?? '');
            setEmail(user?.email ?? '');
            setPhone(user?.phone_number ?? '');
            setCountry(user?.country ?? '');
            setCanShare(user?.can_share ?? false);
            setCreateEdits(user?.create_edits ?? false);
            setCanUseApp(user?.can_use_app ?? false);
            setIsVerified(user?.is_verified ?? true);
            setSessionCount(user?.session_limit_count ?? 2);
        }

        GameService.getAllSubscriptions().then((res) => {
            setSubscription(res.filter((item) => item.name === 'coach')[0]);
        });
    }, [open, mode, user]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{`${mode} User`}</DialogTitle>
            <DialogContent dividers style={{ display: 'flex', gap: '16px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
                    <UploadButton
                        class_name="admin-user-view"
                        id_name="admin-user-logo"
                        dirName={process.env.REACT_APP_DIR_USER}
                        img={userLogo ? (userLogo.includes(process.env.REACT_APP_S3_URI) ? userLogo : process.env.REACT_APP_S3_URI + userLogo) : USER_IMAGE_DEFAULT}
                        onURL={(url) => setUserLogo(url)}
                    />
                    <div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={canShare} // use checked instead of value for a checkbox
                                    onChange={(e) => setCanShare(e.target.checked)} // change to checked
                                    sx={{
                                        margin: "10px",
                                        borderRadius: '10px',
                                        height: '28px',
                                        '& .MuiSvgIcon-root': { fontSize: 28 } // Adjust size of the checkbox icon
                                    }}
                                />
                            }
                            label="Can Share"
                            sx={{ width: '100%' }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={canUseApp}
                                    onChange={(e) => setCanUseApp(e.target.checked)}
                                    sx={{
                                        margin: "10px",
                                        borderRadius: '10px',
                                        height: '28px',
                                        '& .MuiSvgIcon-root': { fontSize: 28 }
                                    }}
                                />
                            }
                            label="Can Use App"
                            sx={{ width: '100%' }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={createEdits} // use checked instead of value for a checkbox
                                    onChange={(e) => setCreateEdits(e.target.checked)} // change to checked
                                    sx={{
                                        margin: "10px",
                                        borderRadius: '10px',
                                        height: '28px',
                                        '& .MuiSvgIcon-root': { fontSize: 28 } // Adjust size of the checkbox icon
                                    }}
                                />
                            }
                            label="Create Edits"
                            sx={{ width: '100%' }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isVerified}
                                    onChange={(e) => setIsVerified(e.target.checked)}
                                    sx={{
                                        margin: "10px",
                                        borderRadius: '10px',
                                        height: '28px',
                                        '& .MuiSvgIcon-root': { fontSize: 28 }
                                    }}
                                />
                            }
                            label="Verified"
                            sx={{ width: '100%' }}
                        />

                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
                    <TextField
                        value={firstName}
                        label="First Name"
                        variant="outlined"
                        autoFocus
                        onChange={(e) => setFirstName(e.target.value)}
                        sx={{ borderRadius: '10px', height: '48px', width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                    <TextField
                        value={email}
                        label="Email Address"
                        variant="outlined"
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ borderRadius: '10px', height: '48px', width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                    <TextField
                        value={country}
                        label="Country"
                        variant="outlined"
                        onChange={(e) => setCountry(e.target.value)}
                        sx={{ borderRadius: '10px', height: '48px', width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
                    <TextField
                        value={lastName}
                        label="Last Name"
                        variant="outlined"
                        onChange={(e) => setLastName(e.target.value)}
                        sx={{ borderRadius: '10px', height: '48px', width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                    <TextField
                        value={phone}
                        label="Phone Number"
                        variant="outlined"
                        onChange={(e) => setPhone(e.target.value)}
                        sx={{ borderRadius: '10px', height: '48px', width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                    <TextField
                        value={sessionCount}
                        label="Session Count"
                        variant="outlined"
                        type="number"
                        onChange={(e) => setSessionCount(e.target.value)}
                        sx={{ borderRadius: '10px', height: '48px', width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="outlined" disabled={firstName === '' || lastName === '' || email === '' || phone === '' || country === '' || sessionCount === 0} onClick={() => saveChanges()}>
                    {mode === 'Add' ? 'Add' : 'Update'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UserDialog;
